export const SidebarSpacer = ({ children }: React.PropsWithChildren) => {
  return <div className="mb-6">{children}</div>;
};

export default SidebarSpacer;
